/**
 *
 * Asynchronously loads the component for AuthenticatedRoute
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AuthenticatedRoute = lazyLoad(
  () => import('./index'),
  module => module.AuthenticatedRoute,
);
